
/*
Base Class for any dialog based content.
The layoutURL that loadLayout calls should include the (excluding the
outer wrapper div that sets the class as modal, etc)
markup for the dialog itself, in a generic form, usually
as a jsrender template that dynamic data will be loaded into
 */

(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    slice = [].slice,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  exports.DialogHandler = (function(superClass) {
    extend(DialogHandler, superClass);

    function DialogHandler() {
      var args;
      args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      DialogHandler.__super__.constructor.apply(this, args);
      this.layoutSelector = null;
      this.refreshNavHandler = true;
      this.defaultSave = true;
      this.saveData = {};
      this.saveUrl = '';
      this.emptySidebarWriter = false;
      this.async = true;
      this.submitBindings = true;
      this.draggable = true;
      this.resizable = true;
      this.startPosition = 'center';
      this.useMessageWriter = true;
      this.slideUpForm = true;
      this.modalOptions = {};
      this.savingBtnMsg = 'Saving...';
      this.savedBtnMsg = 'Saved';
      this.classes = '';
      this.allow_overflow = false;
      this.id = (new Date()).getTime();
      this.saveAction = function() {
        return void 0;
      };
      this.errorAction = function() {
        return void 0;
      };
      this.successAction = function() {
        return void 0;
      };
      this.afterHidden = (function(_this) {
        return function() {
          if (!_this.refreshing) {
            _this.destroy();
          }
          return _this.refreshing = false;
        };
      })(this);
      this.destroyOnSave = true;
      this.delayAfterSuccess = false;
      this.refreshing = false;
    }

    DialogHandler.prototype.init = function() {
      return void 0;
    };

    DialogHandler.prototype.submitAction = function() {
      return void 0;
    };

    DialogHandler.prototype.bindForSubmit = function() {
      this.clearSubmitBind();
      this.dialog.bind('keypress', (function(_this) {
        return function(e) {
          if (e.keyCode === 13) {
            e.preventDefault();
            return _this.submitAction();
          }
        };
      })(this));
      this.dialog.on('keypress', 'textarea', (function(_this) {
        return function(e) {
          return e.stopPropagation();
        };
      })(this));
      this.dialog.delegate('form', 'submit', (function(_this) {
        return function(e) {
          e.preventDefault();
          return _this.submitAction();
        };
      })(this));
      return this.dialog.delegate('.save-btn', 'click', (function(_this) {
        return function() {
          var f;
          f = _this.dialog.find('form');
          if (f.length > 0) {
            return f.submit();
          } else {
            return _this.submitAction();
          }
        };
      })(this));
    };

    DialogHandler.prototype.clearSubmitBind = function() {
      this.dialog.unbind('keypress');
      this.dialog.undelegate('form', 'submit');
      return this.dialog.undelegate('.save-btn', 'click');
    };

    DialogHandler.prototype.createDialog = function(loadOpts) {
      var classlist, defaults, id, opts;
      if (loadOpts == null) {
        loadOpts = {};
      }

      /*
      Adds the actual div that will be modalized, then content is loaded later
       */
      id = this.id;
      classlist = "modal hide " + this.classes;
      if (!this.allow_overflow) {
        classlist = "no-overflow " + classlist;
      }
      $('#bs2-container').append("<div class='" + classlist + "' id='" + id + "'></div>");
      this.layoutSelector = "#" + id;
      this.dialog = $(this.layoutSelector);
      defaults = {
        callback: (function(_this) {
          return function(selector, data) {
            var writer;
            if (_this.resizable) {
              _this.dialog.resizable({
                alsoResize: _this.dialog.find('.modal-body')
              });
            }
            if (_this.draggable) {
              _this.dialog.draggable({
                handle: '.modal-header'
              });
            }
            if (_this.useMessageWriter) {
              writer = _this.dialog.find('.message_writer');
              if (writer.length !== 0) {
                writer.message_writer({
                  autoHide: false
                });
              }
            }
            if (_this.submitBindings) {
              _this.bindForSubmit();
            }
            return _this.afterLoadLayout(selector, data);
          };
        })(this)
      };
      opts = $.extend(defaults, loadOpts);
      this.makeModal(this.modalOptions);
      return this.loadLayout(opts);
    };

    DialogHandler.prototype.makeModal = function(modal_options) {
      var defaultModal, modeOpts;
      if (modal_options == null) {
        modal_options = {};
      }
      defaultModal = {
        show: false,
        backdrop: false
      };
      modeOpts = $.extend(defaultModal, modal_options);
      this.dialog.modal(modeOpts);
      return this.dialog.on('hidden', (function(_this) {
        return function(e) {
          if ($(e.target).is(_this.dialog)) {
            _this.dialog.off();
            return _this.afterHidden();
          }
        };
      })(this));
    };

    DialogHandler.prototype.displayLoadingMessage = function(message) {
      this.dialog.addClass('dialog-loading');
      if (message == null) {
        message = 'Loading data...';
      }
      return this.dialog.html("<div class='shield'>" + message + "</div>");
    };

    DialogHandler.prototype.openDialog = function() {
      var ref;
      if (this.dialog != null) {
        this.dialog.modal('show');
      }
      if ((ref = this.dialog.find('input,select')[0]) != null) {
        ref.focus();
      }
      if (this.startPosition != null) {
        return this.setPosition(this.startPosition);
      }
    };

    DialogHandler.prototype.closeDialog = function() {
      if (this.dialog != null) {
        return this.dialog.modal('hide');
      }
    };

    DialogHandler.prototype.afterLoadLayout = function() {
      return void 0;
    };

    DialogHandler.prototype.destroy = function() {
      if (this.dialog != null) {
        this.closeDialog();
        this.dialog.remove();
      }
      return DialogHandler.__super__.destroy.call(this);
    };

    DialogHandler.prototype.refresh = function() {
      this.refreshing = true;
      this.closeDialog();
      if (this.dialog != null) {
        this.dialog.remove();
      }
      return DialogHandler.__super__.refresh.call(this);
    };

    DialogHandler.prototype.getPostData = function() {
      var saveData;
      saveData = this.dialog.find('form').serialize();
      if (this.saveData) {
        if (saveData) {
          saveData += '&';
        }
        if (this.saveData) {
          saveData += $.param(this.saveData);
        }
      }
      return saveData;
    };

    DialogHandler.prototype.save = function(msg) {
      var contentType, processData, saveBtn, saveData, self, writer;
      self = this;
      document.activeElement.blur();
      if (this.useMessageWriter) {
        writer = self.dialog.find('.message_writer');
      }
      self.beforeSave();
      if (self.defaultSave) {
        saveData = self.getPostData();

        /* Validate saveData here... */
        if (this.useMessageWriter && writer.length !== 0 && $.contains(document, writer[0])) {
          writer.message_writer('info', msg);
        }
        saveBtn = self.dialog.find('.save-btn');
        if (saveBtn.length) {
          if (!saveBtn.attr('data-saving-text')) {
            saveBtn.attr('data-saving-text', self.savingBtnMsg);
          }
          if (!saveBtn.attr('data-saved-text')) {
            saveBtn.attr('data-saved-text', self.savedBtnMsg);
          }
          saveBtn.button('saving').prop('disabled', true);
          setTimeout(function() {
            return saveBtn.prop('disabled', true);
          }, 0);
        }
        processData = true;
        contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
        if (saveData instanceof FormData) {
          processData = false;
          contentType = false;
        }
        return $.ajax({
          type: 'POST',
          url: self.saveUrl,
          data: saveData,
          processData: processData,
          contentType: contentType,
          async: self.async,
          success: function(response) {
            var ref;
            if (self.destroyOnSave && ((ref = response.status) != null ? ref.type : void 0) === 'success') {
              saveBtn.button('saved').prop('disabled', true);
              setTimeout(function() {
                return saveBtn.prop('disabled', true);
              }, 0);
            } else {
              saveBtn.button('reset');
            }

            /*
            See Dialog_Handler.afterSave(). This handles displaying errors
            and closing the dialog/refreshing the current Primary Nav Handler
             */
            return self.afterSave(response);
          },
          error: function() {
            saveBtn.button('reset');
            return self.errorAction();
          }
        });
      } else {
        return self.saveAction();
      }
    };

    DialogHandler.prototype.beforeSave = function() {
      return void 0;
    };

    DialogHandler.prototype.listMessages = function(messages) {
      var k, o, v;
      if (messages == null) {
        messages = {};
      }
      if (Object.keys(messages).length > 1) {
        o = '<ul>';
        for (k in messages) {
          v = messages[k];
          o += "<li>" + v + "</li>";
        }
        o += '</ul>';
        return o;
      } else {
        for (k in messages) {
          v = messages[k];
          return v;
        }
      }
    };

    DialogHandler.prototype.afterSave = function(data, timeout) {
      var o, ref, ref1, ref2, ref3, ref4, ref5, ref6, self, writer;
      if (timeout == null) {
        timeout = 2000;
      }
      self = this;
      writer = self.dialog.find('.message_writer');
      if ((data != null) && ((ref = data.status) != null ? ref.type : void 0) === 'logout') {
        window.location = '/home';
        return;
      }
      if (this.useMessageWriter) {
        o = (ref1 = data.status) != null ? ref1.msg : void 0;
        if (((ref2 = data.status) != null ? ref2.type : void 0) !== 'success') {
          if (((ref3 = data.data) != null ? ref3.messages : void 0) != null) {
            o += self.listMessages((ref4 = data.data) != null ? ref4.messages : void 0);
          }
        }
        if (writer.length !== 0 && $.contains(document, writer[0])) {
          writer.message_writer((ref5 = data.status) != null ? ref5.type : void 0, o);
        }
      }
      if (((ref6 = data.status) != null ? ref6.type : void 0) === 'success') {
        if (this.useMessageWriter && writer.length !== 0 && $.contains(document, writer[0])) {
          writer.message_writer('hide', timeout);
        }
        if (!self.delayAfterSuccess) {
          self.successAction(data);
        }
        if (self.slideUpForm) {
          self.dialog.find('form').slideUp();
        }
        return setTimeout((function(_this) {
          return function() {
            var ref7;
            if (self.delayAfterSuccess) {
              self.successAction(data);
            }
            if (self.destroyOnSave) {
              self.destroy();
            }
            if (self.refreshNavHandler) {
              return (ref7 = App.current_page) != null ? typeof ref7.refreshSubHandlers === "function" ? ref7.refreshSubHandlers() : void 0 : void 0;
            }
          };
        })(this), timeout);
      } else {
        return self.errorAction(data);
      }
    };


    /*
    afterLoadData: () ->
         * Resizeable /must/ happen after template render
        @dialog.resizable
            alsoResize: '.modal-body'
        @dialog.draggable
            handle: '.modal-header'
    
    
    refreshDialog: () ->
    
    loadData: (postopts) ->
        if @dataUrl?
            $.post @dataUrl,postopts,(data) =>
                out = data.data ? {}
                output = $(@template).render(out)
                @dialog.html(output)
    
                @afterLoadData()
     */

    DialogHandler.prototype.setPosition = function(str) {
      var dialogHeight, dialogWidth, heightDiff, horizPos, horizWords, middleWords, pos, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, vertPos, vertWords, widthDiff, windowHeight, windowWidth, words;
      if (str == null) {
        str = null;
      }
      str = str != null ? str : this.startPosition;
      if ((str == null) || typeof str !== 'string' || !str.length) {
        return;
      }
      debugLog('positioning dialog at ' + str);
      words = str.split(/\s+|\s*,\s*/);
      vertWords = ['top', 'bottom'];
      horizWords = ['left', 'right'];
      middleWords = ['center', 'middle'];
      if (words.length === 1) {
        if (ref = words[0], indexOf.call(vertWords, ref) >= 0) {
          vertPos = words[0];
          horizPos = 'middle';
        } else if (ref1 = words[0], indexOf.call(horizWords, ref1) >= 0) {
          vertPos = 'middle';
          horizPos = words[0];
        } else if (ref2 = words[0], indexOf.call(middleWords, ref2) >= 0) {
          vertPos = 'middle';
          horizPos = 'middle';
        }
      } else if (words.length === 2) {
        if (ref3 = words[0], indexOf.call(vertWords, ref3) >= 0) {
          vertPos = words[0];
        } else if (ref4 = words[1], indexOf.call(vertWords, ref4) >= 0) {
          vertPos = words[1];
        }
        if (ref5 = words[1], indexOf.call(horizWords, ref5) >= 0) {
          horizPos = words[1];
        } else if (ref6 = words[0], indexOf.call(horizWords, ref6) >= 0) {
          horizPos = words[0];
        }
        if (ref7 = words[0], indexOf.call(middleWords, ref7) >= 0) {
          if (horizPos != null) {
            vertPos = 'middle';
          } else if (vertPos != null) {
            horizPos = 'middle';
          } else {
            vertPos = 'middle';
          }
        }
        if (ref8 = words[1], indexOf.call(middleWords, ref8) >= 0) {
          if (vertPos != null) {
            horizPos = 'middle';
          } else if (horizPos != null) {
            vertPos = 'middle';
          } else {
            vertPos = 'middle';
          }
        }
      }
      if ((horizPos == null) || (vertPos == null)) {
        debugLog('Failed to parse position');
        return;
      }
      debugLog('Parsed as ' + vertPos + ' ' + horizPos);
      pos = {
        margin: '0px',
        top: 'auto',
        bottom: 'auto',
        left: 'auto',
        right: 'auto'
      };
      windowWidth = $(window).width();
      dialogWidth = $(this.dialog).width();
      widthDiff = windowWidth - dialogWidth;
      debugLog(("window width: " + windowWidth + ", dlg width: " + dialogWidth + ", middle: ") + (windowWidth - dialogWidth) / 2);
      switch (horizPos) {
        case 'left':
          pos.left = 0;
          break;
        case 'middle':
          pos.left = widthDiff / 2;
          break;
        case 'right':
          pos.left = widthDiff;
          break;
        default:
          return;
      }
      if (widthDiff < 0) {
        pos.left = widthDiff;
      }
      pos.left += 'px';
      windowHeight = $(window).height();
      dialogHeight = $(this.dialog).height();
      heightDiff = windowHeight - dialogHeight;
      debugLog('window height: ' + windowHeight + ', dialog height: ' + dialogHeight + ', middle: ' + (windowHeight - dialogHeight) / 2);
      switch (vertPos) {
        case 'top':
          pos.top = 0;
          break;
        case 'middle':
          pos.top = heightDiff / 2;
          break;
        case 'bottom':
          pos.top = heightDiff;
          break;
        default:
          return;
      }
      if (heightDiff < 0) {
        pos.top = heightDiff;
      }
      pos.top += 'px';
      this.dialog.css(pos);
      return debugLog((this.dialog.css('top')) + "/" + (this.dialog.css('bottom')) + ", " + (this.dialog.css('left')) + "/" + (this.dialog.css('right')));
    };

    return DialogHandler;

  })(Handler);

}).call(this);
